import PropTypes from "prop-types";

export const AddonProps = {
    name: PropTypes.string,
    image: PropTypes.string,
    details: PropTypes.shape({
        co2: PropTypes.number,
        energy: PropTypes.number,
        water: PropTypes.number,
    }),
    description: PropTypes.string,
    quantity: PropTypes.number,
    increment: PropTypes.func,
    decrement: PropTypes.func,
    isBasic: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.string),
};
